import * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProjectChargesSearchQueryVariables = Types.Exact<{
  dateAfter?: Types.InputMaybe<Types.Scalars['String']>;
  projectSupervisor?: Types.InputMaybe<Types.Scalars['String']>;
  customerNumber?: Types.InputMaybe<Types.Scalars['String']>;
  billable?: Types.InputMaybe<Types.BillableFilter>;
  dateBefore?: Types.InputMaybe<Types.Scalars['String']>;
  projectManager?: Types.InputMaybe<Types.Scalars['String']>;
  billingAdmin?: Types.InputMaybe<Types.Scalars['String']>;
  state?: Types.InputMaybe<Types.ProjectChargeSearchFilterState>;
  searchText?: Types.InputMaybe<Types.Scalars['String']>;
  dateEqual?: Types.InputMaybe<Types.Scalars['String']>;
  projectNumber?: Types.InputMaybe<Types.Scalars['Int']>;
  afeWoPo?: Types.InputMaybe<Types.Scalars['String']>;
  officeCode?: Types.InputMaybe<Types.Scalars['String']>;
  employee?: Types.InputMaybe<Types.Scalars['String']>;
  token?: Types.InputMaybe<Types.Scalars['String']>;
  sortBy?: Types.InputMaybe<Types.ProjectSortBy>;
}>;


export type ProjectChargesSearchQuery = { __typename?: 'QueryModel', projectCharges?: { __typename?: 'ProjectChargesQueryModel', search?: { __typename?: 'ConnectionOfProjectCharge', token?: string | null, records?: Array<{ __typename?: 'ProjectCharge', id: number, label: string, notes?: string | null, date: string, rate: number, quantity?: number | null, timesheetQuantity?: number | null, unit?: Types.RateUnit | null, total?: number | null, state: Types.ProjectChargeState, billable: boolean, eeCode: string, taxable: boolean, glAccount?: string | null, projectId: number, canAdjust: boolean, canSplit: boolean, canPsApprove: boolean, canBaApprove: boolean, canPmApprove: boolean, canEditTaxable: boolean, canEditBillable: boolean, canMoveProject: boolean, canPostToInvoice: boolean, canOverrideRate: boolean, lastEditNotes?: string | null, canEditDate: boolean, type: Types.ChargeType, rateSheetName?: string | null, isThirdParty: boolean, project?: { __typename?: 'Project', name: string, number: number, budget?: number | null, afe?: string | null, po?: string | null, wo?: string | null, costCenter?: string | null, canAddCharge: boolean, status: Types.ProjectStatus, billingAdmin?: { __typename?: 'Employee', firstName: string, lastName: string, userPrincipalName: string, ultiProId: string } | null, projectManager?: { __typename?: 'Employee', firstName: string, lastName: string, userPrincipalName: string, ultiProId: string } | null, projectSupervisor?: { __typename?: 'Employee', firstName: string, lastName: string, userPrincipalName: string, ultiProId: string } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null, customer?: { __typename?: 'Customer', name: string, number?: string | null } | null, stats?: { __typename?: 'ProjectStats', totalUnbilled: number, totalBilled: number, totalPrPending: number, totalPendingApproval: number, totalPendingBilling: number, totalPmPending: number, totalNonBillable: number, totalPostedNotBilled: number, totalPostPending: number } | null } | null, employee?: { __typename?: 'Employee', firstName: string, lastName: string, middleInitial: string, userPrincipalName: string, ultiProId: string } | null, history?: Array<{ __typename?: 'ProjectChangedHistoryItem', changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeBillableHistoryItem', billable: boolean, editNotes: string, changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeEditedHistoryItem', label: string, notes?: string | null, rate: number, quantity?: number | null, billable: boolean, editNotes: string, eeCode: string, date?: string | null, changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeEeCodeHistoryItem', eeCode: string, editNotes: string, changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeHistoryItem', changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeHistoryItemDetailed', label: string, notes?: string | null, rate: number, quantity?: number | null, billable: boolean, eeCode: string, date?: string | null, changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeQuantityHistoryItem', changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeTaxableHistoryItem', taxable: boolean, changedBy: string, changedOn: any, event: string } | null> | null } | null> | null } | null } | null };

export type ProjectChargesSearchWithStatsQueryVariables = Types.Exact<{
  dateAfter?: Types.InputMaybe<Types.Scalars['String']>;
  projectSupervisor?: Types.InputMaybe<Types.Scalars['String']>;
  customerNumber?: Types.InputMaybe<Types.Scalars['String']>;
  billable?: Types.InputMaybe<Types.BillableFilter>;
  dateBefore?: Types.InputMaybe<Types.Scalars['String']>;
  projectManager?: Types.InputMaybe<Types.Scalars['String']>;
  billingAdmin?: Types.InputMaybe<Types.Scalars['String']>;
  state?: Types.InputMaybe<Types.ProjectChargeSearchFilterState>;
  searchText?: Types.InputMaybe<Types.Scalars['String']>;
  dateEqual?: Types.InputMaybe<Types.Scalars['String']>;
  projectNumber?: Types.InputMaybe<Types.Scalars['Int']>;
  afeWoPo?: Types.InputMaybe<Types.Scalars['String']>;
  officeCode?: Types.InputMaybe<Types.Scalars['String']>;
  employee?: Types.InputMaybe<Types.Scalars['String']>;
  token?: Types.InputMaybe<Types.Scalars['String']>;
  sortBy?: Types.InputMaybe<Types.ProjectSortBy>;
}>;


export type ProjectChargesSearchWithStatsQuery = { __typename?: 'QueryModel', projectCharges?: { __typename?: 'ProjectChargesQueryModel', stats?: { __typename?: 'ProjectChargeSearchStats', chargeTotal: number, projectTotal: number } | null, search?: { __typename?: 'ConnectionOfProjectCharge', token?: string | null, records?: Array<{ __typename?: 'ProjectCharge', id: number, label: string, notes?: string | null, date: string, rate: number, quantity?: number | null, timesheetQuantity?: number | null, unit?: Types.RateUnit | null, total?: number | null, state: Types.ProjectChargeState, billable: boolean, eeCode: string, glAccount?: string | null, taxable: boolean, projectId: number, canAdjust: boolean, canSplit: boolean, canPsApprove: boolean, canBaApprove: boolean, canPmApprove: boolean, canEditTaxable: boolean, canEditBillable: boolean, canMoveProject: boolean, canPostToInvoice: boolean, canOverrideRate: boolean, lastEditNotes?: string | null, canEditDate: boolean, type: Types.ChargeType, rateSheetName?: string | null, isThirdParty: boolean, project?: { __typename?: 'Project', name: string, number: number, budget?: number | null, afe?: string | null, po?: string | null, wo?: string | null, costCenter?: string | null, canAddCharge: boolean, status: Types.ProjectStatus, billingAdmin?: { __typename?: 'Employee', firstName: string, lastName: string, userPrincipalName: string, ultiProId: string } | null, projectManager?: { __typename?: 'Employee', firstName: string, lastName: string, userPrincipalName: string, ultiProId: string } | null, projectSupervisor?: { __typename?: 'Employee', firstName: string, lastName: string, userPrincipalName: string, ultiProId: string } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null, customer?: { __typename?: 'Customer', name: string, number?: string | null } | null, stats?: { __typename?: 'ProjectStats', totalUnbilled: number, totalBilled: number, totalBilledWithoutTax: number, totalPrPending: number, totalPendingApproval: number, totalPendingBilling: number, totalPmPending: number, totalNonBillable: number, totalPostedNotBilled: number, totalPostPending: number } | null, overheadEeCode?: { __typename?: 'EeCodeRecord', eeCode: string } | null } | null, employee?: { __typename?: 'Employee', firstName: string, lastName: string, middleInitial: string, userPrincipalName: string, ultiProId: string } | null, history?: Array<{ __typename?: 'ProjectChangedHistoryItem', changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeBillableHistoryItem', billable: boolean, editNotes: string, changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeEditedHistoryItem', label: string, notes?: string | null, rate: number, quantity?: number | null, billable: boolean, editNotes: string, eeCode: string, date?: string | null, changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeEeCodeHistoryItem', eeCode: string, editNotes: string, changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeHistoryItem', changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeHistoryItemDetailed', label: string, notes?: string | null, rate: number, quantity?: number | null, billable: boolean, eeCode: string, date?: string | null, changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeQuantityHistoryItem', changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeTaxableHistoryItem', taxable: boolean, changedBy: string, changedOn: any, event: string } | null> | null } | null> | null } | null } | null };


export const ProjectChargesSearchDocument = gql`
    query ProjectChargesSearch($dateAfter: String, $projectSupervisor: String, $customerNumber: String, $billable: BillableFilter, $dateBefore: String, $projectManager: String, $billingAdmin: String, $state: ProjectChargeSearchFilterState, $searchText: String, $dateEqual: String, $projectNumber: Int, $afeWoPo: String, $officeCode: String, $employee: String, $token: String, $sortBy: ProjectSortBy) {
  projectCharges {
    search(
      dateAfter: $dateAfter
      projectSupervisor: $projectSupervisor
      customerNumber: $customerNumber
      billable: $billable
      dateBefore: $dateBefore
      projectManager: $projectManager
      billingAdmin: $billingAdmin
      state: $state
      searchText: $searchText
      dateEqual: $dateEqual
      projectNumber: $projectNumber
      afeWoPo: $afeWoPo
      officeCode: $officeCode
      employee: $employee
      token: $token
      sortBy: $sortBy
    ) {
      token
      records {
        id
        label
        notes
        date
        rate
        quantity
        timesheetQuantity
        unit
        total
        state
        billable
        eeCode
        taxable
        glAccount
        projectId
        project {
          name
          number
          budget
          billingAdmin {
            firstName
            lastName
            userPrincipalName
            ultiProId
          }
          projectManager {
            firstName
            lastName
            userPrincipalName
            ultiProId
          }
          projectSupervisor {
            firstName
            lastName
            userPrincipalName
            ultiProId
          }
          location {
            state
            county
          }
          customer {
            name
            number
          }
          stats {
            totalUnbilled
            totalBilled
            totalPrPending
            totalPendingApproval
            totalPendingBilling
            totalPmPending
            totalNonBillable
            totalPostedNotBilled
            totalPostPending
          }
          afe
          po
          wo
          costCenter
          canAddCharge
          status
        }
        employee {
          firstName
          lastName
          middleInitial
          userPrincipalName
          ultiProId
        }
        history {
          changedBy
          changedOn
          event
          ... on ProjectChargeHistoryItemDetailed {
            label
            notes
            rate
            quantity
            billable
            eeCode
            date
          }
          ... on ProjectChargeEditedHistoryItem {
            label
            notes
            rate
            quantity
            billable
            editNotes
            eeCode
            date
          }
          ... on ProjectChargeTaxableHistoryItem {
            taxable
          }
          ... on ProjectChargeBillableHistoryItem {
            billable
            editNotes
          }
          ... on ProjectChargeEeCodeHistoryItem {
            eeCode
            editNotes
          }
        }
        canAdjust
        canSplit
        canPsApprove
        canBaApprove
        canPmApprove
        canEditTaxable
        canEditBillable
        canMoveProject
        canPostToInvoice
        canOverrideRate
        lastEditNotes
        canEditDate
        type
        rateSheetName
        isThirdParty
      }
    }
  }
}
    `;

/**
 * __useProjectChargesSearchQuery__
 *
 * To run a query within a React component, call `useProjectChargesSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectChargesSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectChargesSearchQuery({
 *   variables: {
 *      dateAfter: // value for 'dateAfter'
 *      projectSupervisor: // value for 'projectSupervisor'
 *      customerNumber: // value for 'customerNumber'
 *      billable: // value for 'billable'
 *      dateBefore: // value for 'dateBefore'
 *      projectManager: // value for 'projectManager'
 *      billingAdmin: // value for 'billingAdmin'
 *      state: // value for 'state'
 *      searchText: // value for 'searchText'
 *      dateEqual: // value for 'dateEqual'
 *      projectNumber: // value for 'projectNumber'
 *      afeWoPo: // value for 'afeWoPo'
 *      officeCode: // value for 'officeCode'
 *      employee: // value for 'employee'
 *      token: // value for 'token'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useProjectChargesSearchQuery(baseOptions?: Apollo.QueryHookOptions<ProjectChargesSearchQuery, ProjectChargesSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectChargesSearchQuery, ProjectChargesSearchQueryVariables>(ProjectChargesSearchDocument, options);
      }
export function useProjectChargesSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectChargesSearchQuery, ProjectChargesSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectChargesSearchQuery, ProjectChargesSearchQueryVariables>(ProjectChargesSearchDocument, options);
        }
export type ProjectChargesSearchQueryHookResult = ReturnType<typeof useProjectChargesSearchQuery>;
export type ProjectChargesSearchLazyQueryHookResult = ReturnType<typeof useProjectChargesSearchLazyQuery>;
export type ProjectChargesSearchQueryResult = Apollo.QueryResult<ProjectChargesSearchQuery, ProjectChargesSearchQueryVariables>;
export const ProjectChargesSearchWithStatsDocument = gql`
    query ProjectChargesSearchWithStats($dateAfter: String, $projectSupervisor: String, $customerNumber: String, $billable: BillableFilter, $dateBefore: String, $projectManager: String, $billingAdmin: String, $state: ProjectChargeSearchFilterState, $searchText: String, $dateEqual: String, $projectNumber: Int, $afeWoPo: String, $officeCode: String, $employee: String, $token: String, $sortBy: ProjectSortBy) {
  projectCharges {
    stats(
      dateAfter: $dateAfter
      projectSupervisor: $projectSupervisor
      customerNumber: $customerNumber
      billable: $billable
      dateBefore: $dateBefore
      projectManager: $projectManager
      billingAdmin: $billingAdmin
      state: $state
      searchText: $searchText
      dateEqual: $dateEqual
      projectNumber: $projectNumber
      afeWoPo: $afeWoPo
      officeCode: $officeCode
      employee: $employee
    ) {
      chargeTotal
      projectTotal
    }
    search(
      dateAfter: $dateAfter
      projectSupervisor: $projectSupervisor
      customerNumber: $customerNumber
      billable: $billable
      dateBefore: $dateBefore
      projectManager: $projectManager
      billingAdmin: $billingAdmin
      state: $state
      searchText: $searchText
      dateEqual: $dateEqual
      projectNumber: $projectNumber
      afeWoPo: $afeWoPo
      officeCode: $officeCode
      employee: $employee
      token: $token
      sortBy: $sortBy
    ) {
      token
      records {
        id
        label
        notes
        date
        rate
        quantity
        timesheetQuantity
        unit
        total
        state
        billable
        eeCode
        glAccount
        taxable
        projectId
        project {
          name
          number
          budget
          billingAdmin {
            firstName
            lastName
            userPrincipalName
            ultiProId
          }
          projectManager {
            firstName
            lastName
            userPrincipalName
            ultiProId
          }
          projectSupervisor {
            firstName
            lastName
            userPrincipalName
            ultiProId
          }
          location {
            state
            county
          }
          customer {
            name
            number
          }
          stats {
            totalUnbilled
            totalBilled
            totalBilledWithoutTax
            totalPrPending
            totalPendingApproval
            totalPendingBilling
            totalPmPending
            totalNonBillable
            totalPostedNotBilled
            totalPostPending
          }
          afe
          po
          wo
          costCenter
          canAddCharge
          overheadEeCode {
            eeCode
          }
          status
        }
        employee {
          firstName
          lastName
          middleInitial
          userPrincipalName
          ultiProId
        }
        history {
          changedBy
          changedOn
          event
          ... on ProjectChargeHistoryItemDetailed {
            label
            notes
            rate
            quantity
            billable
            eeCode
            date
          }
          ... on ProjectChargeEditedHistoryItem {
            label
            notes
            rate
            quantity
            billable
            editNotes
            eeCode
            date
          }
          ... on ProjectChargeTaxableHistoryItem {
            taxable
          }
          ... on ProjectChargeBillableHistoryItem {
            billable
            editNotes
          }
          ... on ProjectChargeEeCodeHistoryItem {
            eeCode
            editNotes
          }
        }
        canAdjust
        canSplit
        canPsApprove
        canBaApprove
        canPmApprove
        canEditTaxable
        canEditBillable
        canMoveProject
        canPostToInvoice
        canOverrideRate
        lastEditNotes
        canEditDate
        type
        rateSheetName
        isThirdParty
      }
    }
  }
}
    `;

/**
 * __useProjectChargesSearchWithStatsQuery__
 *
 * To run a query within a React component, call `useProjectChargesSearchWithStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectChargesSearchWithStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectChargesSearchWithStatsQuery({
 *   variables: {
 *      dateAfter: // value for 'dateAfter'
 *      projectSupervisor: // value for 'projectSupervisor'
 *      customerNumber: // value for 'customerNumber'
 *      billable: // value for 'billable'
 *      dateBefore: // value for 'dateBefore'
 *      projectManager: // value for 'projectManager'
 *      billingAdmin: // value for 'billingAdmin'
 *      state: // value for 'state'
 *      searchText: // value for 'searchText'
 *      dateEqual: // value for 'dateEqual'
 *      projectNumber: // value for 'projectNumber'
 *      afeWoPo: // value for 'afeWoPo'
 *      officeCode: // value for 'officeCode'
 *      employee: // value for 'employee'
 *      token: // value for 'token'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useProjectChargesSearchWithStatsQuery(baseOptions?: Apollo.QueryHookOptions<ProjectChargesSearchWithStatsQuery, ProjectChargesSearchWithStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectChargesSearchWithStatsQuery, ProjectChargesSearchWithStatsQueryVariables>(ProjectChargesSearchWithStatsDocument, options);
      }
export function useProjectChargesSearchWithStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectChargesSearchWithStatsQuery, ProjectChargesSearchWithStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectChargesSearchWithStatsQuery, ProjectChargesSearchWithStatsQueryVariables>(ProjectChargesSearchWithStatsDocument, options);
        }
export type ProjectChargesSearchWithStatsQueryHookResult = ReturnType<typeof useProjectChargesSearchWithStatsQuery>;
export type ProjectChargesSearchWithStatsLazyQueryHookResult = ReturnType<typeof useProjectChargesSearchWithStatsLazyQuery>;
export type ProjectChargesSearchWithStatsQueryResult = Apollo.QueryResult<ProjectChargesSearchWithStatsQuery, ProjectChargesSearchWithStatsQueryVariables>;